var mainFormSubmitted = false;
var franchiseMap;
var franchiseKmlLayer;

function setupHeadOfficeEventTracking()
{
    $("a[href^='tel:']").click(function()
    {
        var action = $(this).attr("href") + " - " + location.pathname;
        if ($(this).data("analytics") != null)
        {
            action += " - " + $(this).data("analytics");
        }
        ga("send", "event", "Head Office", "Phone Numbers", action);
    });
    $("a[href^='mailto:']").click(function()
    {
        var action = $(this).attr("href") + " - " + location.pathname;
        if ($(this).data("analytics") != null)
        {
            action += " - " + $(this).data("analytics");
        }
        ga("send", "event", "Head Office", "Email Addresses", action);
    });
    $("a[href*='.pdf'],a[href*='.doc'],a[href*='.xls'],a[href*='.zip'],a[href*='.rar'],a[href*='.pps'],a[href*='.ppt'],a[href*='.mp4'],a[href*='.avi'],a[href*='.mov'],a[href*='.mp3'],a[href*='.wav'],a[href*='.wma'],a[href*='.m4a']").click(
        function()
        {
            ga("send", "event", "Head Office", "Downloads", location.pathname);
        });
    $("a").click(function()
    {
        var link = $(this).attr("href");
        if ((link.indexOf(location.host) === -1 && link.indexOf("blog.lockforce.co.uk") === -1) && (link.indexOf("http:") === 0 || link.indexOf("https:") === 0))
        {
            ga("send", "event", "Head Office", "External Links", $(this).attr("href"));
        }
    });
    $(".home-search a[id$=_btnSubmit], .find-locksmith a[id$=_btnSubmit]").click(function()
    {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ "search_term": $(".home-search input[id$=_txtPostcode], .find-locksmith input[id$=_txtPostcode]").val() });
        window.dataLayer.push({ "event": "postcode_search" });

        ga("send", "event", "Head Office", "Search", $(".home-search input[id$=_txtPostcode], .find-locksmith input[id$=_txtPostcode]").val());
    });
}

function setupFranchiseEventTracking()
{
    $("a[href^='tel:']").click(function()
    {
        var action = $(this).attr("href");
        if ($(this).data("analytics") != null)
        {
            action += " - " + $(this).data("analytics");
        }
        ga("send", "event", franchise_name, "Phone Numbers", action);
        ga("franchise.send", "event", franchise_name, "Phone Numbers", action);
    });
    $("a[href^='mailto:']").click(function()
    {
        var action = $(this).attr("href");
        if ($(this).data("analytics") != null)
        {
            action += " - " + $(this).data("analytics");
        }
        ga("send", "event", franchise_name, "Email Addresses", action);
        ga("franchise.send", "event", franchise_name, "Email Addresses", action);
    });
    $("a[href*='.pdf'],a[href*='.doc'],a[href*='.xls'],a[href*='.zip'],a[href*='.rar'],a[href*='.pps'],a[href*='.ppt'],a[href*='.mp4'],a[href*='.avi'],a[href*='.mov'],a[href*='.mp3'],a[href*='.wav'],a[href*='.wma'],a[href*='.m4a']").click(
        function()
        {
            ga("send", "event", franchise_name, "Downloads", location.pathname);
            ga("franchise.send", "event", franchise_name, "Downloads", location.pathname);
        });
    $("a").click(function()
    {
        var link = $(this).attr("href");
        if ((link.indexOf(location.host) !== 0 && link.indexOf("blog.lockforce.co.uk") !== 0) && (link.indexOf("http:") === 0 || link.indexOf("https:") === 0))
        {
            ga("send", "event", franchise_name, "External Links", $(this).attr("href"));
            ga("franchise.send", "event", franchise_name, "External Links", $(this).attr("href"));
        }
    });
}

function blockRepeatedSubmissions()
{
    if (mainFormSubmitted)
    {
        console.log("Repeat page submit blocked");
        return false;
    }

    mainFormSubmitted = true;

    var buttons = document.querySelectorAll("body > form button, body > form input[type=submit]");
    for (var i = 0; i < buttons.length; i++)
    {
        // buttons[i].disabled = true;
        buttons[i].style.opacity = 0.5;
    }
}

function moveToHash(hash)
{
    $(".franchise-tab-wrapper > section").removeClass("active");
    $(".franchise-tab-bar > a").removeClass("active");

    $(".franchise-tab-bar > a[href=" + hash + "]").addClass("active");
    $(".franchise-tab-wrapper > section" + hash).addClass("active");

    if (hash === '#areas' && franchiseMap && franchiseKmlLayer)
    {
        franchiseMap.fitBounds(franchiseKmlLayer.getDefaultViewport());
    }
}

function setupFranchiseSections()
{
    if (window.location.hash && $(".franchise-tab-bar > a[href=" + window.location.hash + "]").length > 0)
    {
        moveToHash(window.location.hash);
    }

    $(window).on("hashchange", function (ev)
    {
        if ($(".franchise-tab-bar > a[href=" + window.location.hash + "]").length > 0)
        {
            ev.preventDefault();
            moveToHash(window.location.hash);
        }
    });
}

function setupFranchiseMap()
{
    var map = $("[data-gmap-kml]");
    if (map.length === 0)
    {
        return;
    }

    franchiseMap = new google.maps.Map(map[0], {
        center: new google.maps.LatLng(54.237933, -2.36967),
        zoom: 4
    });

    franchiseKmlLayer = new google.maps.KmlLayer(map.data("gmap-kml"), {
        suppressInfoWindows: jQuery("#areas").length !== 0,
        preserveViewport: false,
        map: franchiseMap
    });

    if (jQuery("#areas").length === 0)
    {
        franchiseKmlLayer.addListener("click", function (kmlEvent)
        {
            if (!kmlEvent.featureData.infoWindowHtml)
            {
                return;
            }

            kmlEvent.featureData.infoWindowHtml = kmlEvent.featureData.infoWindowHtml.replace("target=\"_blank\"", "");
        });
    }
}

$(function()
{
    $(".header-nav button").click(function ()
    {
        $(this).siblings("ul").toggleClass("open");
        if ($(this).parent().is(".header-nav") && !$(this).siblings("ul").is(".open"))
        {
            $(".navigation-backdrop").removeClass("open");
        }
        else
        {
            $(".navigation-backdrop").addClass("open");
        }
    });

    $(".navigation-backdrop").click(function ()
    {
        $(".header-nav ul").removeClass("open");
        $(".navigation-backdrop").removeClass("open");
    });

    if (typeof (franchise_name) === "undefined")
    {
        setupHeadOfficeEventTracking();
    }
    else
    {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ "franchise_name": franchise_name });
        setupFranchiseEventTracking();
        setupFranchiseSections();
    }
});